import { Head } from "zudoku/components";
import { useLocation } from "react-router";
import { getLocaleFromPath, LOCALES, swapLocaleInPath } from "../i18n";

const SITE_URL = "https://docs.fluxis.us";
const SITE_NAME = "Fluxis Docs";
const SITE_DESCRIPTION =
  "Fluxis documentation - Crypto and stablecoin payments infrastructure for merchants. Accept cryptocurrency payments with ease.";
const OG_IMAGE = `${SITE_URL}/fluxis_light_mode.svg`;

const WEBSITE_LD = JSON.stringify({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      name: SITE_NAME,
      url: SITE_URL,
      description: SITE_DESCRIPTION,
      inLanguage: ["en", "es", "pt"],
    },
    {
      "@type": "Organization",
      "@id": "https://fluxis.us/#organization",
      name: "Fluxis",
      url: "https://fluxis.us",
      logo: {
        "@type": "ImageObject",
        url: OG_IMAGE,
      },
      sameAs: ["https://github.com/fluxisus", "https://dapp.fluxis.us"],
    },
  ],
});

export function LocaleHeadTags() {
  const location = useLocation();
  const currentLocale = getLocaleFromPath(location.pathname);
  const canonicalUrl = `${SITE_URL}${location.pathname}`;

  return (
    <Head>
      {/* lang attribute on the html element - correct per locale */}
      <html lang={currentLocale} />

      {/* Absolute canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Absolute hreflang alternates */}
      {LOCALES.map((locale) => {
        const localePath = swapLocaleInPath(location.pathname, locale);
        const absoluteUrl = `${SITE_URL}${localePath}`;
        return (
          <link
            key={locale}
            rel="alternate"
            hrefLang={locale}
            href={absoluteUrl}
          />
        );
      })}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${SITE_URL}/docs/introduction/overview`}
      />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:alt" content="Fluxis logo" />
      <meta property="og:description" content={SITE_DESCRIPTION} />

      {/* Twitter / X Card */}
      <meta name="twitter:site" content="@fluxisus" />
      <meta name="twitter:image" content={OG_IMAGE} />

      {/* JSON-LD structured data */}
      <script type="application/ld+json">{WEBSITE_LD}</script>
    </Head>
  );
}
